import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { CardGroupList, CardGroup } from '@/types/index'

// Fetch list of group names from API and normalize to CardGroup[]
export const getCardGroupList = createAsyncThunk<CardGroup[]>(API_ROUTES.ADMIN_CARD_GROUP_LIST_ENDPOINT, async () => {
    const res = await apiClient.get(API_ROUTES.ADMIN_CARD_GROUP_LIST_ENDPOINT)
    console.log('API response for card groups:', res)
    const data = (res as any).data ? (res as any).data : res

    // API returns array of strings like ["group1", "group2"]
    if (Array.isArray(data)) {
        return data.map((item: any) => {
            if (typeof item === 'string') return { group_name: item }
            if (item && typeof item === 'object' && item.group_name) return { group_name: item.group_name }
            return { group_name: String(item) }
        })
    }

    return []
})

const initialState: CardGroupList = {
    card_groups: [],
    loading: false,
    error: null,
}

const adminCardGroupSlice = createSlice({
    name: 'adminCardGroup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET CARD GROUP LIST
            .addCase(getCardGroupList.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getCardGroupList.fulfilled, (state, action) => {
                // action.payload is CardGroup[]
                state.card_groups = action.payload
                state.loading = false
            })
            .addCase(getCardGroupList.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })
    },
})

export default adminCardGroupSlice.reducer
